<template>
  <v-card>
    <v-card-title>
      <span class="headline">Update Gender</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-select
          :items="items"
          v-model="gender"
          color="#4dbac0"
          label="Select"
        ></v-select>
          <div class="errors">
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "modal",
  data() {
    return {
      name: "editGender",
      gender: this.$store.getters.gender,
      errors: new Array(),
      items: ["Male", "Female"]
    };
  },
  methods: {
    close() {
      this.$emit("close", this.name);
      this.username = this.$store.getters.username
    },
    save() {
      this.errors = [];

      if (this.errors.length == 0) {
        this.$store
          .dispatch("updateUserdata", {
            type: "main",
            name: "gender",
            value: this.gender
          })
          .then(() => {
            this.$emit("close", this.name);
            //this.username = this.$store.getters.username
          })
          .catch(() => {
            this.errors.push("Error");
          });
      }
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>